module.exports = __webpack_public_path__ + "71044ef5c6855d2fc2b0a953a01ed13a.ttf";